import { DialogComponent } from '@dialog/dialog.component';
import { ICompany, Company } from '@company/company.structures';
import { CompanyService } from '@company/company.service';
import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ExceptionService } from '@exceptions-service';
import { IErrorResponse, IUser, ICompanyModule, ICreateUpdateCompany,
  IDialogData, IDialogSearchParams, ICheckListParams, ICompanyUserRelated, IUserCompany, IRole } from '@interfaces';
import { Role, User } from '@models';
import { Router, ActivatedRoute } from '@angular/router';
import { IModule } from '@module/module.structure';
import * as fromUtils from '@utils';
import { IGroup } from '@group/group.structure';
import { DialogGroupComponent } from '@group/dialog-group/dialog-group.component';
import { GroupService } from '@group/group.service';
import { FormControlService } from '@base/form-controls.service';
import { FirebaseImagesService } from '@base/firebase-images.service';
import { UserService } from '@user/user.service';
import { AppService } from '@base/app.service';
import { group } from '@angular/animations';
import { ModuleService } from '@base/module/module.service';

@Component({
  selector: 'app-company-form',
  templateUrl: './company-form.component.html',
  styleUrls: ['./company-form.component.sass']
})
export class CompanyFormComponent implements OnInit, OnDestroy {
  ROLES = fromUtils.ROLES;
  MODULE = fromUtils.MODULE;
  private subscriptions: Subscription[];
  private currentUser: User = new User();

  name = new FormControl(null, [
    Validators.required, Validators.maxLength(45),
    Validators.pattern('^[A-Za-z\-\ 0-9\_\ñ]+')
  ]);
  domain = new FormControl(null, [
    Validators.required, Validators.maxLength(20),
    Validators.pattern('^[A-Za-z\-\ 0-9\_\ñ]+')
  ]);
  image_url = new FormControl(null);
  companyForm: FormGroup;
  showSpinner = false;
  edit = false;
  strAction = 'Agregar';
  company: Partial<ICompany>;

  panelsInfo = [
    {
      info: {
        title: 'Clientes',
        description: null,
        icon: 'person',
        gettingData: true,
        footer: '',
        expanded: false,
        relatedName: 'cliente',
        searchButton: true,
        autoActivate: false,
        listType: this.ROLES.CUSTOMER,
        showDescription: false,
        total: {active: 0, inactive: 0},
        searchParams: {
          singleName: 'cliente',
          filter: this.ROLES.CUSTOMER,
          searchKey: 'role__code',
          onlySource: false,
        },
        locked: false,
        pageSize: 5,
        pageSizeOptions: [5, 10, 20],
      },
      data: [],
    },
    {
      info: {
        title: 'Analistas',
        description: null,
        icon: 'supervised_user_circle',
        gettingData: true,
        footer: '',
        expanded: false,
        relatedName: 'analista',
        searchButton: true,
        autoActivate: true,
        showDescription: false,
        total: {active: 0, inactive: 0},
        listType: this.ROLES.ANALYST,
        searchParams: {
          singleName: 'analista',
          filter: this.ROLES.ANALYST,
          searchKey: 'role__code',
          onlySource: false,
        },
        locked: false,
        pageSize: 10,
        pageSizeOptions: [5, 10, 20],
      },
      data: [],
    },
    {
      info: {
        title: 'Módulos',
        description: null,
        icon: 'extension',
        gettingData: true,
        footter: '',
        expanded: false,
        relatedName: 'módulo',
        searchButton: true,
        autoActivate: false,
        showDescription: false,
        total: {active: 0, inactive: 0},
        listType: this.MODULE,
        searchParams: {
          singleName: 'módulo',
          filter: this.MODULE,
          searchKey: '',
          onlySource: false,
        },
        locked: false,
      },
      data: [],
    },
  ];

  groups = {
    info: {
      gettingData: true,
    },
    elements: [],
    data: new BehaviorSubject<any>([]),
  };

  @ViewChild('logo') logoFile: ElementRef;
  showImageProgressBar = false;
  downloadURL: Observable<string>;
  progress: Observable<number>;
  gettingInfo = false;
  gettingGroups = true;
  analyts: IUser[];
  customers: IUser[];
  modules: IModule[];

  filterGroups = '';
  pg1 = 1;

  userCollection = new BehaviorSubject<any>([]);
  analystCollection = new BehaviorSubject<any>([]);
  moduleCollection = new BehaviorSubject<any>([]);
  groupMembers: BehaviorSubject<any>[] = [];

  constructor(
    public fb: FormBuilder,
    private formControlService: FormControlService,
    private router: Router,
    private route: ActivatedRoute,
    public location: Location,
    private mainService: AppService,
    private companyService: CompanyService,
    private groupService: GroupService,
    private userService: UserService,
    private moduleService: ModuleService,
    private exceptionService: ExceptionService,
    public fbService: FirebaseImagesService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {
    this.company = fromUtils.EMPTY;
    this.subscriptions = [];
    this.analyts = [];
    this.customers = [];
    this.modules = [];
    this.companyForm = this.fb.group({
      name: this.name,
      domain: this.domain,
      image_url: this.image_url,
    });
    const usersSubscription = this.userService.observeUsers().subscribe(
      (users: IUser[][]) => {
        this.analyts = users[this.ROLES.ANALYST];
        this.customers = users[this.ROLES.CUSTOMER];
      },
      (e: HttpErrorResponse) => console.log(e)
    );

    const modulesSubsription = this.moduleService.observeModules().subscribe(
      (modules: IModule[]) => this.modules = modules
    );

    const sessionSubs = this.mainService.getCurrentUser().subscribe(this.checkPermissions);

    this.subscriptions = [...this.subscriptions, usersSubscription, sessionSubs, ];
  }

  ngOnInit() {
    let idCompany: number = parseInt(this.route.snapshot.paramMap.get('id'), 10);
    idCompany = (isNaN(parseFloat(String(idCompany)))) ? undefined : idCompany;

    // en caso de estar editando una empresa...
    if (typeof idCompany !== fromUtils.UNDEFINED) {
      this.loadCompany(idCompany);

    // esta agregando una nueva empresa...
    } else if (typeof idCompany === fromUtils.UNDEFINED) {
      this.company = {
        color: '#3f51b5', // default color
        image_url: null,
      };
      this.getRelatedInfo();
    }
  }

  ngOnDestroy() {
    this.subscriptions.map((item: Subscription) => item.unsubscribe());
    this.companyService.setCompany(fromUtils.EMPTY);
  }

  private checkPermissions = (session: IUser) => {
    let panelAnalystsLocked = true;
    let panelModulesLocked = true;
    if (session !== fromUtils.EMPTY) {
      this.currentUser = fromUtils.assignObjectValues(session, new User()) as User;
      const role: IRole = session.role;
      panelAnalystsLocked = (role.code !== this.ROLES.ADMIN && role.code !== this.ROLES.LEADER);
      panelModulesLocked = (role.code !== this.ROLES.ADMIN && role.code !== this.ROLES.LEADER);
    }
    this.panelsInfo[1].info['locked'] = panelAnalystsLocked;
    this.panelsInfo[2].info['locked'] = panelModulesLocked;
  }

  private showCompanyInfo(company: ICompany) {
    if (company !== fromUtils.EMPTY) {
      this.edit = true;
      this.strAction = 'Editar';
      this.company = company;
      this.companyForm.patchValue({
        name: this.company.name,
        domain: this.company.domain,
        image_url: this.company.image_url,
      });
      this.getRelatedInfo();
    }
  }

  loadCompany(id: number) {
    if (this.company === fromUtils.EMPTY) {
      this.edit = true;
      this.strAction = 'Editar';
      this.gettingInfo = true;

      // se esta recargando la pagina, hay que obtener la info desde la api...
      const userSubscription = this.companyService.getCompany(id).subscribe(
        (company: ICompany) => {
          this.gettingInfo = false;
          this.showCompanyInfo(company);
        },
        (err: HttpErrorResponse) => {
          const error: IErrorResponse = this.exceptionService.errorHandling(err);
          this.openSnackBar(error.message, error.title);
        }
      );
    }
  }

  getRelatedInfo() {
    if (typeof this.company !== 'undefined' && this.edit) {
      const users: ICompanyUserRelated[] = (this.company.users.length > 0) ? [...this.company.users] : [];
      const modules = this.company.modules as [];
      const groups = this.company.groups as [];
      const customersRelated = [];
      const analystsRelated = [];
      const modulesRelated = [];

      users.map((element: ICompanyUserRelated | IUser) => {
        const user: Partial<IUser> = (element.hasOwnProperty('user')) ? element['user'] : element;
        const active = (user.hasOwnProperty('active')) ? user['active'] : element['active'];

        const row = {
          id: user.id,
          name: `${user.first_name} ${user.last_name}`,
          related: {
            status: true,
            disabled: false,
          },
          active: {
            status: active,
            disabled: false,
          },
        };

        if (typeof user.role !== 'undefined') {
          if (user.role['code'] === this.ROLES.CUSTOMER) {
            customersRelated.push(row);
          } else if (user.role['code'] === this.ROLES.ANALYST) {
            analystsRelated.push(row);
          }
        } else {
          window.location.reload();
        }

        return null;
      });

      this.panelsInfo[0].data = customersRelated;
      this.panelsInfo[0].info['total'] = this.calculateTotal(customersRelated);
      this.panelsInfo[0].info['showDescription'] = (customersRelated.length > 0);
      this.panelsInfo[0].info.gettingData = false;

      this.panelsInfo[1].data = analystsRelated;
      this.panelsInfo[1].info['total'] = this.calculateTotal(analystsRelated);
      this.panelsInfo[1].info['showDescription'] = (analystsRelated.length > 0);
      this.panelsInfo[1].info.gettingData = false;

      modules.map((element: ICompanyModule | IModule) => {
        const module: Partial<IModule> = (element.hasOwnProperty('module')) ? element['module'] : element;
        const active = (module.hasOwnProperty('active')) ? module['active'] : element['active'];

        const row = {
          id: module.id,
          name: module.name,
          sync: module.tableau_synchronize,
          related: {
            status: true,
            disabled: false,
          },
          active: {
            status: active,
            disabled: false,
          },
        };

        modulesRelated.push(row);
      });

      this.panelsInfo[2].data = modulesRelated;
      this.panelsInfo[2].info['total'] = this.calculateTotal(modulesRelated);
      this.panelsInfo[2].info['showDescription'] = (modulesRelated.length > 0);
      this.panelsInfo[2].info.gettingData = false;

      // preparar los ids de los grupos de la empresa...
      this.gettingGroups = true;
      let listGroupIds: number[] = [];
      groups.map((element: object) => listGroupIds = [...listGroupIds, element['id']]);

      // cargar los grupos de la empresa que se esta mostrando...
      let groupElements = [...this.groups.elements];
      this.groupService.getMultiples({groups: listGroupIds}).subscribe(
        (companyGroups: IGroup[]) => {
          companyGroups.map((groupElement: IGroup) => {
            let members = [];
            // const newMembers = new BehaviorSubject<any>(members);
            // this.groupMembers = [...this.groupMembers, newMembers];

            // preparar los miembros del grupo...
            groupElement.members.map((item) => {
              const statusMember = item['active'];
              const member = {
                id: item['user']['id'],
                name: `${item['user']['first_name']} ${item['user']['last_name']}`,
                related: {
                  status: true,
                  disabled: false,
                },
                active: {
                  status: statusMember,
                  disabled: false,
                },
              };
              members = [...members, member];
              // newMembers.next(members);
            });

            const groupUsers = {
              info: {
                id: groupElement.id,
                title: groupElement.name,
                description: null,
                icon: 'group_work',
                gettingData: false,
                footer: '',
                expanded: false,
                relatedName: 'cliente',
                searchButton: true,
                autoActivate: false,
                total: this.calculateTotal(members),
                searchParams: {
                  singleName: 'cliente',
                  filter: fromUtils.UNFILTERED,
                  searchKey: 'role__code',
                  source: this.panelsInfo[0].data,
                  onlySource: true,
                } as Partial<IDialogSearchParams>
              },
              data: members,
              bsData: new BehaviorSubject<any>(members),
            };
            groupUsers.bsData.next(members);
            groupUsers.info['showDescription'] = (members.length);
            groupElements = [...groupElements, groupUsers, ];
          });
          this.groups.elements = groupElements;
          this.gettingGroups = false;
        },
        (err: HttpErrorResponse) => {
          const error: IErrorResponse = this.exceptionService.errorHandling(err);
          console.log(error.message);
        }
      );  // getMultiples

      this.groups.info.gettingData = false;

      this.userCollection.next(customersRelated);
      this.analystCollection.next(analystsRelated);
      this.moduleCollection.next(modulesRelated);
    } else {
      this.panelsInfo[0].info.gettingData = false;
      this.panelsInfo[1].info.gettingData = false;
      this.panelsInfo[2].info.gettingData = false;
      this.gettingGroups = false;
    }
  }

  onSubmit() {
    this.showSpinner = true;
    this.companyForm.disable();
    let allUsers = [];
    const modules = [];
    const groups = [];
    const finalUsers = this.panelsInfo[0].data.concat(this.panelsInfo[1].data);

    // prepara los datos de users (clientes y analistas) ...
    finalUsers.map((relatedUser) => {
      const user = relatedUser;

      if (user !== fromUtils.EMPTY) {
        const relatedStatus = relatedUser['related']['status'];
        const activeStatus = relatedUser['active']['status'];
        const auxRelatedUser: object = {
          id: user.id,
          related: relatedStatus,
          active: activeStatus,
        };
        allUsers = [...allUsers, auxRelatedUser];
      }

      return null;
    });

    // prepara los datos de los modulos ...
    this.panelsInfo[2].data.map((module) => {
      if (typeof module['id'] !== fromUtils.UNDEFINED) {

        modules.push({
          id: module['id'],
          related: module['related']['status'],
          active: module['active']['status'],
        });
      }
      return null;
    });

    // prepara los datos de los grupos ...
    this.groups.elements.map(groupItem => {
      const users = groupItem['data'] as [];
      const members = [];

      if (users.length) {
        users.map((user) => {
          const member = {
            id: user['id'],
            related: user['related']['status'],
            active: (typeof user['active']['status'] === 'undefined') ? false : user['active']['status'],
            role: this.ROLES.CUSTOMER,
          };
          members.push(member);
        });
      }

      const groupMember = {
        id: groupItem['info'].id,
        name: groupItem['info'].title,
        slug: groupItem['info'].title.trim().toLowerCase().replace(/ /g, '-'),
        members: members,
      };

      groups.push(groupMember);
    });

    const company: ICompany = (!this.edit) ? new Company(this.companyForm.value) : { ...this.company, ...this.companyForm.value, };
    company.slug = company.name.trim().toLowerCase().replace(/ /g, '-');
    company.color = (company.hasOwnProperty('color')) ? company.color : this.company.color;
    company.domain = (company.hasOwnProperty('domain')) ? company.domain : this.company.domain;
    company.users = allUsers;
    company.modules = modules;
    company.groups = groups;

    const obs = (this.edit) ? this.companyService.updateCompany(company) : this.companyService.createCompany(company);
    const redirectBackUrl = localStorage.getItem('temp_url');
    const saveUserSubscription = obs.subscribe(
      (response: ICreateUpdateCompany) => {
        this.showSpinner = false;
        // this.companyService.getCompanies(this.currentUser, {ordering: ['-updated_at', ]});
        saveUserSubscription.unsubscribe();

        this.companyForm.reset();
        this.companyForm.enable();
        if (!this.edit) {
          this.openSnackBar('Empresa registrada con exito', 'info');
          localStorage.removeItem('temp_url');
          this.router.navigate([(redirectBackUrl !== null) ? redirectBackUrl : '/home/companies']);
        } else if (this.edit) {
          this.openSnackBar('Empresa actualizada con exito', 'info');
          this.router.navigate([(redirectBackUrl !== null) ? redirectBackUrl : '/home/companies']);
        }
      },
      (err: HttpErrorResponse) => {
        this.showSpinner = false;
        // this.companyService.getCompanies(this.currentUser, {ordering: ['-updated_at', ]});
        const e: IErrorResponse = this.exceptionService.errorHandling(err);
        this.openSnackBar(e.message, e.title);
        console.log(err.error);
        localStorage.removeItem('temp_url');
        this.router.navigate([(redirectBackUrl !== null) ? redirectBackUrl : '/home/companies']);
      },
    );
  }

  openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 2000,
    });
  }

  createGroup() {
    const newGroup: IGroup = {
      id: 0,
      name: '',
      slug: '',
      company: (this.edit) ? this.company.id : 0,
    };
    const params = {
      title: 'Nuevo Grupo',
      group: newGroup,
      edit: false,
    };
    const dialogRef = this.dialog.open(DialogGroupComponent, {
      width: '350px',
      data: params,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((createdGroup: IGroup) => {
      if ((typeof createdGroup !== 'undefined') && (createdGroup !== null)) {
        const emptyGroupInfo = ((createdGroup.id === 0) && (createdGroup.company === 0));
        const newGroupId = (emptyGroupInfo) ? this.groups.elements.length + 1 : createdGroup.id;

        // encoger todos los paneles de grupos
        this.groups.elements.map(item => {
          item.info.expanded = false;
        });

        const elementGroup = {
          info: {
            id: newGroupId,
            title: createdGroup.name,
            description: null,
            icon: 'group_work',
            gettingData: false,
            footer: '',
            expanded: true,
            relatedName: 'grupo',
            searchButton: true,
            autoActivate: false,
            searchParams: {
              singleName: 'cliente',
              filter: this.ROLES.CUSTOMER,
              searchKey: 'role__code',
              source: this.panelsInfo[0].data,
              onlySource: true
            }
          },
          data: [],
          bsData: new BehaviorSubject<any>([]),
          };
          elementGroup.bsData.next([]);

          this.groups.elements.push(elementGroup);
      }
    });
  }

  private updateUsersState(company: ICompany) {
    const allUsers = this.analyts.concat(this.customers);

    company.users.map((relationship) => {
      const relatedUser = relationship.user;
      const userFound = allUsers.find((user: IUser) => user.id === relatedUser.id);

      if (typeof userFound !== 'undefined') {
        const existingUser: IUser = Object.assign(userFound);
        const objIndex = existingUser.companies.findIndex((rel: IUserCompany) => rel.company.id === company.id);
        if (objIndex >= 0) {existingUser.companies.splice(objIndex, 1); }
      }
    });
  }

  deleteCompany(company: Partial<ICompany>): void {
    const params: IDialogData = {
      strQuestion: `¿Confirma la eliminación de ${company.name}?`,
      strAccept: 'Aceptar',
      strCancel: 'Cancelar',
      buttonColor: 'warn',
    };
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: params,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.companyService.deleteCompany(company).subscribe(() => {
          // this.updateUsersState(Object.assign(company));
          this.openSnackBar(`${company.name} ha sido borrada de la plataforma.`, 'info');
          this.location.back();
        },
        (err: HttpErrorResponse) => {
          const error: IErrorResponse = this.exceptionService.errorHandling(err);
          // this.updateUsersState(Object.assign(company));
          this.openSnackBar(error.title, error.message);
          this.location.back();
        });
      }
    });
  }

  updateList(e: [], listType: string) {
    const objIndex = this.panelsInfo.findIndex((obj => obj.info.listType === listType));
    this.panelsInfo[objIndex].data = e;
  }

  deleteGroup(groupData: object) {
    const selectedGroup: IGroup = {
      id: groupData['info'].id,
      name: groupData['info'].title,
      slug: '',
    };
    const params: IDialogData = {
      strQuestion: `¿Confirma la eliminación del grupo ${selectedGroup.name}?`,
      strAccept: 'Aceptar',
      strCancel: 'Cancelar',
      buttonColor: 'warn',
    };
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '370px',
      data: params,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        if (this.edit) {
          this.groupService.deleteGroup(selectedGroup).subscribe(
            response => {
              this.openSnackBar(`El Grupo ${selectedGroup.name} ha sido eliminado con exito`, 'info');
              const objIndex = this.groups.elements.findIndex((obj => obj.info.id === selectedGroup.id));
              this.groups.elements.splice(objIndex, 1);
            },
            (err: HttpErrorResponse) => {
              const error: IErrorResponse = this.exceptionService.errorHandling(err);
              this.openSnackBar(error.message, error.title);
            }
          );
        } else if (!this.edit) {
          const indexToRemove = this.groups.elements.findIndex((element) => element.info.id === groupData['info'].id);
          this.groups.elements.splice(indexToRemove, 1);
        }
      }
    });
  }

  renameGroup(groupData: object) {
    const selectedGroup: IGroup = {
      id: groupData['info'].id,
      name: groupData['info'].title,
      slug: '',
      company: (this.edit) ? this.company.id : 0,
    };
    const params = {
      title: 'Renombrar Grupo',
      group: selectedGroup,
      edit: true,
    };
    const dialogRef = this.dialog.open(DialogGroupComponent, {
      width: '350px',
      data: params,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((response: IGroup) => {
      if ((typeof response !== 'undefined') && (response !== null)) {
        const objIndex = this.groups.elements.findIndex((obj => obj.info.id === selectedGroup.id));
        this.groups.elements[objIndex]['info']['title'] = response.name;
      }
    });
  }

  updateGroup(e, editedGroup) {
    editedGroup['data'] = e;
  }

  calculateTotal(elements: any[]) {
    const inactive = elements.filter((item) => item['active']['status'] === false).length;
    const total = {
      inactive: inactive,
      active: elements.length - inactive,
    };
    return total;
  }

  openGroup(groupProfile: object) {
    const selectedGroup: ICheckListParams = groupProfile['info'];
    selectedGroup.showDescription = false;
  }

  closeGroup(groupProfile: object) {
    const selectedGroup: ICheckListParams = groupProfile['info'];
    selectedGroup.total = this.calculateTotal(groupProfile['data'] as []);
    selectedGroup.showDescription = true;
  }

  openPanel(panelDetail: object) {
    // definir el rol de usuario
    const userRole = this.mainService.roles.filter(
      (role: Role) => role.code === panelDetail['info']['listType']
    )[0];

    if (typeof userRole !== 'undefined') {
      this.userService.selectedRole = userRole;
    }

    const selectedGroup: ICheckListParams = panelDetail['info'];
    selectedGroup.showDescription = false;
  }

  closePanel(panelDetail: object) {
    const item: ICheckListParams = panelDetail['info'];
    item.total = this.calculateTotal(panelDetail['data'] as []);
    item.showDescription = true;
  }

  updateColor(newColor: string) {
    this.company.color = newColor;
  }

  getErrorMessage(control: FormControl) {
    const strError = this.formControlService.checkErrorInControl(control);
    return strError;
  }

  validImageUrl(uri: string) {
    const sanitzedUri = uri;
    const n = sanitzedUri.search('token=');
    // ?alt=media&token=0e378e1f-82fe-46a0-ac87-21d397e31469
    // https://firebasestorage.googleapis.com/v0/b/biwiser.appspot.com/o/companies%2FLimonada_logo.png
    return (n >= 0);
  }

  upload(event) {
    let file: File = event.target.files[0];
    const statusFile = this.fbService.validFile(file);

    if (statusFile['error']) {
      file = undefined;
      this.logoFile.nativeElement.value = '';
      this.openSnackBar(statusFile['strMessage'], 'Atención');
    } else {
      this.showImageProgressBar = true;
      this.fbService.uploadImage(file);
      this.downloadURL = this.fbService.downloadURL;
      this.progress = this.fbService.uploadProgress;
      this.progress.subscribe((value: number) => {
        if (value === 100) {
          this.downloadURL.subscribe(
            (uri: string) => {
              this.company.image_url = (this.validImageUrl(uri)) ? uri : null;
              this.companyForm.patchValue({image_url: uri, });
              setTimeout(() => {
                this.showImageProgressBar = false;
              }, 700);
            },
            (err: HttpErrorResponse) => {
              const error: IErrorResponse = this.exceptionService.errorHandling(err);
              file = undefined;
              this.logoFile.nativeElement.value = '';
              this.showImageProgressBar = false;
            }
          );
        }},
        err => console.log(err)
      );
    }
  }
}
